import { render, staticRenderFns } from "./aboutCen.vue?vue&type=template&id=c278b076&scoped=true"
import script from "./aboutCen.vue?vue&type=script&lang=js"
export * from "./aboutCen.vue?vue&type=script&lang=js"
import style1 from "./aboutCen.vue?vue&type=style&index=1&id=c278b076&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c278b076",
  null
  
)

export default component.exports